<template>
  <div class="table_wrap">
    <el-table :data="boardData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              @selection-change="tableSelectChange"
              height="695"
    >
      <el-table-column
          type="selection"
          class-name="text-center"
          min-width="25">
      </el-table-column>

      <el-table-column
          class="table_no"
          type="index"
          label="No"
          min-width="45"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>

      <el-table-column
          class="table_stats"
          label="상태"
          min-width="25"
          class-name="text-center"
      >
        <template slot-scope="scope">
          {{ setStats(scope.row) }}
        </template>
      </el-table-column>

      <el-table-column min-width="155" label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
      <el-table-column label="작성일자" min-width="150" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{ returnDate(scope.row.wr_datetime) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="상세" min-width="90" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <el-button @click="goDetail(scope.row.wr_id)">
              상세
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from "@/mixins/util";

export default {
  name: "BoardListDefaultLayout",
  mixins: [],
  components: {},
  inject: {
    setPage: {
      default: () => {
      }
    },
    boardListSetData: {
      default: () => {
      }
    },
    setFilter: {
      default: () => {
      }
    },
  },
  provide() {
    return {}
  },
  props: {
    boardType: '',
    boardData: {
      default: () => {
        return []
      }
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    tableSelectChange(row) {
      this.selectArr = [];
      util.Array.each(row, (obj, index, arr) => {
        this.selectArr.push(obj.wr_id);
      });
      this.boardListSetData('selectArr', this.selectArr)
    },
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
    goDetail(key) {
      this.$router.replace(`${this.$route.path}?tab=${this.boardType}`)
      this.$nextTick(() => {
        this.$router.push(`${this.$route.path}/${this.boardType}/${key}`);
      })
    },
    setStats(value = null) {
      if (!util.isEmpty(value.NoticeFile)) {
        if (!util.isEmpty(value.NoticeFile) && !util.isEmpty(value.ImportantFile)) {
          if (!util.isEmpty(value.ImportantFile.File[0]) && !util.isEmpty(value.NoticeFile.File[0])) {
            return '메인노출,상단노출'
          } else if (!util.isEmpty(value.ImportantFile.File[0])) {
            return '상단노출'
          } else if (!util.isEmpty(value.NoticeFile.File[0])) {
            return '메인노출'
          } else {
            return '일반'
          }
        } else {
          if (!util.isEmpty(value.NoticeFile.File[0])) {
            return '메인노출'
          } else {
            return '일반'
          }
        }
      } else {
        return '일반'
      }
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>